export interface Category {
  id: string;
  name: string;
  url: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-sb-x1',
  },
  {
    id: 'hoodies',
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageSeq: 'cat-hoodies-sb-x1',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageSeq: 'cat-tshirts-sb-x1',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageSeq: 'cat-jackets-sb-x1',
  },
  {
    id: 'pants',
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageSeq: 'cat-pants-sb-x1',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageSeq: 'cat-headwear-sb-x1',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageSeq: 'cat-sets-sb-x1',
  },
  {
    id: 'underwear',
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageSeq: 'cat-underwear-sb-x1',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageSeq: 'cat-jersey-sb-x1',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageSeq: 'cat-accessories-sb-x1',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageSeq: 'cat-bags-sb-x1',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageSeq: 'cat-belts-sb-x1',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageSeq: 'cat-perfumes-sb-x1',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageSeq: 'cat-other-sb-x1',
  },
];